import { Badge } from "components/ui/badge";

import { PRIORITY_LEVELS, priorityLevelOf } from "../constants/priority-levels";

interface PriorityBadgeProps {
  value: unknown;

  showPrefix?: boolean;
}

export function PriorityBadge({
  value,
  showPrefix = true,
}: PriorityBadgeProps): JSX.Element {
  const level = PRIORITY_LEVELS[priorityLevelOf(value)];
  return (
    <Badge variant="outline" className={level.badgeClassName}>
      {showPrefix ? `Prioridade ${level.label}` : level.label}
    </Badge>
  );
}
